//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableEmptyData from '@/components/Shared/Table/TableEmptyData'

export default {
  name: 'OnGoingProjectsSection',
  components: {
    TableEmptyData,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    columns() {
      return [
        {
          label: 'Proyecto',
          field: 'project_name',
          sortable: true,
        },
        {
          label: 'Total de usuarios',
          field: 'total_employees',
          centered: true,
          sortable: true,
          cellClass: 'table-cells',
        },
        {
          label: 'Nº finalizados',
          field: 'finished_questionaries',
          centered: true,
          cellClass: 'table-cells',
          sortable: true,
        },
      ]
    },
  },
}
